<div>
  <p id="title" class="heading-01-bold">Seleccione fecha de baja</p>
  <!-- Claramente esta para mejorar -->
  <input
    matInput
    class="date-picker"
    [value]="this.today"
    (change)="datepickerChange($event)"
    type="date"
  />
</div>
